import React, { useRef, useState } from "react";
import Image from "../images/Image";
import { AnimatePresence } from "framer-motion";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../store";
import { setLanguage } from "../../store/slices/languageSlice";
import { toTitleCase } from "../commonfunctions/TitleCase";
import useOutsideClick from "../CustomHooks/useOutsideClick";
import DropdownFramer from "../framerMotion/DropdownFramer";
import DropdownItemsFramer from "../framerMotion/DropdownItemsFramer";
import PTagFramer from "../framerMotion/PTagFramer";
import { SideBarContent } from "../layouts/SideBarContent";
import useTranslation from "../CustomHooks/useTranslation";

interface ImageProps {
  image: string;
}

const LanguageChanger: React.FC<ImageProps> = ({ image }) => {
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  
  const languages = {
    "english": "English",
    "dari": "دری", 
    "pashto": "پشتو",
    "uzbeki": "ازبکی"
  };

  const { language } = useSelector((state: RootState) => state.language);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const { translate } = useTranslation(SideBarContent);

  const languageChangeHandler = (languageKey: string) => {
    dispatch(setLanguage(languageKey));
    setDropdownVisible(false);
  };

  // This code is used for the outside click closing of the dropdown
  useOutsideClick(dropdownRef, () => setDropdownVisible(false));

  return (
    <div
      ref={dropdownRef}
      dir="ltr"
      className="dropdown-container relative w-[121px] h-[44px]"
      data-testid="language-changer"
    >
      <input
        type="text"
        id="myInput"
        className="cursor-not-allowed px-2.5 py-3 outline-hidden rounded-md w-full h-full shadow-md"
        // Note - Temporarily disabled the language change button as per client request
        // Change Cursor Pointer to Not-Allowed, and disable the input
        // onClick={() => setDropdownVisible(!isDropdownVisible)}
        value={translate(toTitleCase(language))}
        data-testid="language-dropdown"
        readOnly
      />

      {/* Framer Motion arrow image with rotation animation */}
      <DropdownFramer
        className="absolute top-2 right-1"
        isDropdownVisible={isDropdownVisible}
      >
        <Image
          src={image}
          // Note - Temporarily disabled the language change button as per client request
          // onClick={() => setDropdownVisible(!isDropdownVisible)}
          disabled={true}
        />
      </DropdownFramer>

      {/* Dropdown content with animation */}
      <AnimatePresence>
        {isDropdownVisible && (
          <DropdownItemsFramer className="dropdown-content py-2 px-2 w-full absolute bg-white mt-1 rounded-md shadow-lg">
            {Object.entries(languages)
              .filter(([langKey]) => langKey !== language)
              .map(([langKey, langValue]  ) => (
                <PTagFramer key={langKey}>
                  <p
                    className="w-full p-2.5 hover:bg-blue-50 rounded-lg cursor-pointer"
                    onClick={() => languageChangeHandler(langKey)}
                    data-testid={`language-${langKey}`}
                  >
                    {toTitleCase(langValue)}
                  </p>
                </PTagFramer>
              ))
            }
          </DropdownItemsFramer>
        )}
      </AnimatePresence>
    </div>
  );
};

export default LanguageChanger;